import MenuIcon from "@mui/icons-material/Menu";
import { grey, white } from "designSystem/styles/color";
import { ComponentItemDataStore } from "designSystem/utilities/component-item-functions";
import { CsiImage, DataGridSingleSelect, FlexRowCenter, GridColumn, GridRow, Select } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import CardDataGridSingleSelect from "csi/middleware/card/CardDataGridSingleSelect";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { SetEditColorCard } from "../SetEditForm";
import { usePresentationPageStore } from "../main";
import { usePPValidationStore } from "./PPValidationStore";

export interface PickProductComponentProps {
	/** the data store for the color */
	colorDataStore?: ComponentItemDataStore<ComponentItem>;

	/** the selected color url */
	colorUrl: string;

	/** handler for select product */
	onSelectProduct?: (productUrl: string) => void;

	/** handler for select color */
	onSelectColor?: (colorUrl: string) => void;

	/** the selected product url */
	productUrl: string;
}

export const PickProductComponent = (props: PickProductComponentProps) => {
	const {
		colorDataStore,
		colorUrl,
		onSelectProduct,
		onSelectColor,
		productUrl,
	} = props;

	const { primaryType, productColorType, cache, validationStore, getDisableItemForColor, getDisableItemForProduct } = usePresentationPageStore();
	const { productCardNodeStore, disableColor, getDisplayTextForColor, getDisplayTextForProduct, supportColor } = validationStore;
	const colorNode = cache.get(colorUrl);
	const disable = disableColor(productUrl);

	return (
		<GridColumn spacing={5}>
			<GridRow
				flexWrap="nowrap"
				item
				spacing={2}
			>
				<GridColumn item>
					<CardDataGridSingleSelect
						getDisableItem={getDisableItemForProduct}
						getDisplayText={getDisplayTextForProduct}
						nodeType={primaryType}
						onSelectCard={onSelectProduct}
						store={productCardNodeStore}
						value={productUrl}
					/>
				</GridColumn>
				{supportColor && (
					<GridColumn item>
						<DataGridSingleSelect
							GridCard={SetEditColorCard}
							disabled={disable}
							getDisableItem={getDisableItemForColor}
							getDisplayText={getDisplayTextForColor}
							itemType={productColorType}
							onSelectItem={onSelectColor}
							store={colorDataStore}
							value={colorUrl}
						/>
					</GridColumn>
				)}
			</GridRow>
			{colorNode && (
				<GridRow item>
					<FlexRowCenter
						bgcolor={white[50]}
						border={`1px dashed ${grey[400]}`}
						height={200}
						justifyContent="center"
						width={200}
					>
						<CsiImage
							aspectRatio={1}
							node={colorNode}
							width={200}
						/>
					</FlexRowCenter>
				</GridRow>
			)}
		</GridColumn>
	);
};

export interface PPResolutionProps { }
const PPResolution: FunctionComponent<PPResolutionProps> = observer((props) => {
	const {
		productColorItem,
		resolutionItems,
		showActionToReplaceProduct,
		selectTopLevelAction,
		setGlobalProductUrl,
		topLevelActionIndex,
	} = usePPValidationStore();

	const {
		colorDataStore,
		colorItemUrl,
		productUrl,
		setColorItemUrl,
	} = productColorItem || {};

	return (
		<GridColumn spacing={5}>
			<GridRow
				growAllChildren
				item
				style={{ width: 408 }}
			>
				<Select
					fullWidth
					items={resolutionItems}
					onSelectItem={selectTopLevelAction}
					startIcon={<MenuIcon color="action" />}
					value={topLevelActionIndex}
				/>
			</GridRow>
			{showActionToReplaceProduct && (
				<GridRow item>
					<PickProductComponent
						colorDataStore={colorDataStore}
						colorUrl={colorItemUrl}
						onSelectColor={setColorItemUrl}
						onSelectProduct={setGlobalProductUrl}
						productUrl={productUrl}
					/>
				</GridRow>
			)}
		</GridColumn>
	);
});

export default PPResolution;